import React, { Component } from "react";
import Licenses from "../../../components/Licenses/Licenses";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : LicensesForm
Description : Compoente que alberga el formulario de Licenses definido en el directorio de componentes
Date Autor Modification
================================================================================
29/09/2022 Santiago Coca - Se define el componente
================================================================================ */

class LicensesForm extends Component {
    render() {
        return (
            <Licenses />
        )
    }
}

export default LicensesForm;